// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInput_container__25ouT","icon":"SearchInput_icon__lVK6_","clearButton":"SearchInput_clearButton__1hU01"};